<template>
    <page noPadding :showDashboardButton="true">
        <!-- <template v-slot:header>
      <ion-title>Menü</ion-title>
    </template> -->
        <h1>Menü</h1>
        <ion-grid>
            <ion-row>
                <ion-col size="12">
                    <ion-list>
                        <ion-item
                            button
                            v-if="$store.state.isLoggedIn"
                            @click="changePage({ name: 'profil' })"
                        >
                            <span slot="start" class="icon-kamel"></span>
                            <ion-label>Mein Profil</ion-label>
                        </ion-item>
                        <ion-item
                            button
                            @click="changePage({ name: 'schadensmeldung' })"
                        >
                            <span
                                slot="start"
                                class="icon-schadensmeldung"
                            ></span>
                            <ion-label>Schadensmeldung</ion-label>
                        </ion-item>
                        <ion-item button @click="changePage({ name: 'me1ns' })">
                            <span slot="start" class="icon-herz"></span>
                            <ion-label>me1ns</ion-label>
                        </ion-item>
                        <ion-item
                            button
                            @click="changePage({ name: 'dokbox' })"
                        >
                            <span slot="start" class="icon-dokbox"></span>
                            <ion-label>DokBox</ion-label>
                        </ion-item>
                        <!-- <ion-item
                            button
                            @click="
                                changePage(
                                    'https://www.klickmal.at/pages/lebenscheck.html'
                                )
                            "
                        >
                            <span slot="start" class="icon-lebenscheck"></span>
                            <ion-label>LebensCheck</ion-label>
                        </ion-item> -->

                        <ion-item
                            button
                            @click="changePage('https://www.mein-leben.at')"
                        >
                            <span slot="start" class="icon-magazin"></span>
                            <ion-label>Magazin</ion-label>
                        </ion-item>
                        <ion-item
                            button
                            @click="
                                changePage(
                                    'https://www.klickmal.at/pages/kontakt.html?zone=allgemein&tab=berater'
                                )
                            "
                        >
                            <span
                                slot="start"
                                class="icon-berater_suche"
                            ></span>
                            <ion-label>Beratersuche</ion-label>
                        </ion-item>
                        <!-- <ion-item
                            button
                            @click="
                                changePage(
                                    'https://www.klickmal.at/wohnen/immoflexkredit/wohntraumzuckerl.html'
                                )
                            "
                        >
                            <span slot="start" class="icon-stern"></span>
                            <ion-label>Weiterempfehlen</ion-label>
                        </ion-item> -->
                        <!-- 
      <ion-item
        button
        @click="changePage('http://www.infohub.at/klickmal_app_demo')"
      >
        App Demo
      </ion-item> -->

                        <ion-item
                            button
                            @click="changePage({ name: 'einstellungen' })"
                        >
                            <span
                                slot="start"
                                class="icon-einstellungen"
                            ></span>
                            <ion-label>Einstellungen</ion-label>
                        </ion-item>

                        <ion-item
                            button
                            @click="
                                changePage(
                                    'https://www.klickmal.at/app/tutorials.html'
                                )
                            "
                        >
                            <span slot="start" class="icon-tutorial"></span>
                            <ion-label>Tutorials</ion-label>
                        </ion-item>

                        <ion-item button @click="changePage({ name: 'hilfe' })">
                            <span slot="start" class="icon-hilfe"></span>
                            <ion-label>Brauchst du Hilfe?</ion-label>
                        </ion-item>

                        <!-- <ion-item
              button
              @click="changePage('https://www.klickmal.at/pages/impressum.html')"
            >
              <span
                slot="start"
                class="icon-recht"
              ></span>
              <ion-label>Impressum</ion-label>
            </ion-item> -->

                        <!-- <ion-item
        button
        @click="logout('/login')"
      >
        Logout
      </ion-item> -->
                    </ion-list>
                </ion-col>

                <ion-col size="12">
                    <ion-button
                        v-if="$store.state.isLoggedIn"
                        expand="block"
                        @click="logout()"
                    >
                        Logout
                    </ion-button>
                </ion-col>
            </ion-row>
        </ion-grid>
    </page>
</template>

<script>
import Page from "@/components/Page";
import { logout } from "@/api/auth";
// import { Plugins } from "@capacitor/core";

export default {
    components: { Page },
    data() {
        return {
            isNative: Capacitor.isNative,
        };
    },
    mounted() {},
    methods: {
        changePage(path) {
            this.$router.push(path);
            //   this.$refs.menu.close();
        },
        logout() {
            this.$ionic.alertController
                .create({
                    header: "Logout",
                    message: "Möchtest du dich wirklich ausloggen?",
                    buttons: [
                        {
                            text: "Nein",
                            role: "cancel",
                        },
                        {
                            text: "Ja",
                            handler: () => {
                                this.$store.commit("setLoading", true);
                                logout();
                            },
                        },
                    ],
                })
                .then((a) => a.present());
        },
    },
};
</script>

<style style="scss" scoped>
ion-grid,
ion-row {
    /* height: 100%; */
    /* justify-content: space-between; */
}
[class^="icon-"],
[class*=" icon-"] {
    font-size: x-large;
}

.ios [class^="icon-"],
.ios [class*=" icon-"] {
    margin-left: 16px;
}

.md [class^="icon-"],
.md [class*=" icon-"] {
    margin-left: 32px;
}

ion-item {
    --ion-item-background: var(--ion-color-step-100);
}

ion-button {
    margin-left: var(--ion-padding, 16px);
    margin-right: var(--ion-padding, 16px);
}

h1 {
    margin-left: var(--ion-padding, 16px);
}
</style>
